import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const englishOrFrench: AnswerPathTreeNode = { path: 'englishOrFrench', nodeId: NodeIds.insuredEnglishOrFrench };
